export const environment = {
  production: false,
  AuthServiceBaseUrl: 'https://dev.school.auth-api.hospitalease.in', 
  OrgServiceBaseUrl: 'https://dev.school.org-api.hospitalease.in', 
  SchoolServiceBaseUrl:'https://dev.school.school-api.hospitalease.in',
  FeeServiceBaseUrl: 'https://dev.school.fee-api.hospitalease.in',
  SharedServiceBaseUrl: 'https://dev.school.shared-api.hospitalease.in',
  StudentServiceBaseUrl:'https://dev.school.student-api.hospitalease.in',
  appName: 'School ERP(Dev)'
};
